import { extendTheme } from '@chakra-ui/react';
const themeProps = extendTheme({
  ...extendTheme,
});

export const ishaTheme = themeProps;
